import { h, Component } from "preact"
import PropTypes from "prop-types"
import style from "./MerchantInfoDrawer.sass"
import i18next from "../../i18n/i18n"
import payButtonIcon from "../../assets/icons/shield-money-green.svg"
import securePaymentsByLogo from "../../assets/icons/pago-seguro-wompi-desktop.svg"
import cibestLogo from "../../assets/icons/grupo-cibest-primary.svg"
import bankIdentityIcon from "../../assets/icons/cards.svg"
import secureCardIcon from "../../assets/icons/shield-money.svg"
import documentCheck from "../../assets/icons/document-check.svg"
import phoneIcon from "../../assets/icons/phone-contact.svg"
import mailIcon from "../../assets/icons/mail.svg"
import copyIcon from "../../assets/icons/copy.svg"
import checkIcon from "../../assets/icons/check.svg"

export default class MerchantInfoDrawer extends Component {
  constructor(props) {
    super(props)
    this.merchant_contact = {}
    this.state = {
      copiedField: null,
    }
    this.copyFeedbackTimeout = null
  }

  componentDidMount() {
    const { store } = this.props
    const hasAction = typeof store?.$actions?.get_merchant_contact === "function"
    const hasOperation = typeof store?.$operations?.getMerchantContactByPublicKey === "function"
    const hasMerchantPublicKey = store?.$state?.transaction?.merchant?.publicKey

    if (hasAction && hasOperation && hasMerchantPublicKey) {
      store.$actions.get_merchant_contact().then((res) => {
        this.merchant_contact = res || {}
        this.forceUpdate()
      })
    }
  }

  componentWillUnmount() {
    if (this.copyFeedbackTimeout) {
      clearTimeout(this.copyFeedbackTimeout)
    }
  }

  copyToClipboard = async (value, field) => {
    if (!value) return

    const showCopiedFeedback = () => {
      if (this.copyFeedbackTimeout) {
        clearTimeout(this.copyFeedbackTimeout)
      }
      this.setState({ copiedField: field })
      this.copyFeedbackTimeout = setTimeout(() => {
        this.setState({ copiedField: null })
      }, 1000)
    }

    try {
      await navigator.clipboard.writeText(value)
      showCopiedFeedback()
    } catch (error) {
      console.warn("Clipboard copy failed", error)
    }
  }

  renderVerificationItem = ({ icon, textKey, strongKey }) => {
    return (
      <li key={textKey}>
        <span className={style.listIcon}>
          <img src={icon} alt="" aria-hidden="true" className={style.listIconImage} />
        </span>
        <span className={style.listText}>
          <span>{i18next.t(textKey)} </span>
          <strong>({i18next.t(strongKey)})</strong>
        </span>
      </li>
    )
  }

  renderContactRow = ({ labelKey, value, field, icon }) => {
    const { copiedField } = this.state
    const resolvedValue = value || ""
    const isCopied = copiedField === field

    return (
      <div className={style.infoRow} key={field}>
        <span className={style.infoLabel}>{i18next.t(labelKey)}</span>
        <div className={style.infoMain}>
          <span className={style.infoChip}>
            <img src={icon} alt="" aria-hidden="true" className={style.infoChipIcon} />
            <span>{resolvedValue}</span>
          </span>
          <button
            type="button"
            className={style.copyButton}
            onClick={() => this.copyToClipboard(resolvedValue, field)}
            aria-label={i18next.t("paymentLinkInfo.drawer.copy")}
            title={i18next.t("paymentLinkInfo.drawer.copy")}
          >
            <img
              src={isCopied ? checkIcon : copyIcon}
              alt=""
              aria-hidden="true"
              className={isCopied ? style.copyButtonIconSuccess : style.copyButtonIcon}
            />
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { isOpen, onClose, merchantName } = this.props

    if (!isOpen) return null

    const verificationItems = [
      {
        icon: bankIdentityIcon,
        textKey: "paymentLinkInfo.drawer.verifyBankIdentity",
        strongKey: "paymentLinkInfo.drawer.threeDSecure",
      },
      {
        icon: secureCardIcon,
        textKey: "paymentLinkInfo.drawer.secureCardInfo",
        strongKey: "paymentLinkInfo.drawer.pciDss",
      },
    ]

    const contactItems = [
      {
        labelKey: "paymentLinkInfo.drawer.callMerchant",
        value: this.merchant_contact.phoneNumber,
        field: "phone",
        icon: phoneIcon,
      },
      {
        labelKey: "paymentLinkInfo.drawer.sendEmail",
        value: this.merchant_contact.email,
        field: "email",
        icon: mailIcon,
      },
    ]

    return (
      <div className={style.overlay}>
        <button
          type="button"
          className={style.backdrop}
          onClick={onClose}
          aria-label="Close drawer"
        />
        <aside className={style.drawer}>
          <button
            type="button"
            className={style.closeButton}
            onClick={onClose}
            aria-label={i18next.t("paymentLinkInfo.drawer.close")}
          >
            ×
          </button>
          <div className={style.drawerContent}>
            <div className={style.topSection}>
              <div className={style.verifiedBadge}>
                <span className={style.badgeIcon}>
                  <img src={documentCheck} alt="" aria-hidden="true" className={style.badgeIconImage} />
                </span>
                <span className={style.verifiedBadgeText}>
                  {i18next.t("paymentLinkInfo.drawer.merchantInformation")}
                </span>
              </div>
              <div className={style.merchantIdentity}>
                <h2 className={style.merchantName} title={merchantName}>
                  {merchantName}
                </h2>
              </div>
            </div>

            <hr className={style.separator} />

            <div className={style.contentSection}>
              <h3 className={style.sectionTitle}>
                {i18next.t("paymentLinkInfo.drawer.verifyInfo")}
              </h3>
              <ul className={style.verificationList}>
                {verificationItems.map(this.renderVerificationItem)}
              </ul>
            </div>

            <hr className={style.separator} />

            <div className={style.contactSection}>
              <h3 className={style.sectionTitle}>
                {i18next.t("paymentLinkInfo.drawer.pqrInfo")}
              </h3>
              {contactItems.map(this.renderContactRow)}
            </div>

            <div className={style.footerSection}>
              <button type="button" className={style.payButton} onClick={onClose}>
                <img src={payButtonIcon} alt="" aria-hidden="true" className={style.payButtonIcon} />
                <span className={style.payButtonText}>
                  {i18next.t("paymentLinkInfo.drawer.continuePayment")}
                </span>
              </button>
              <div className={style.securityLogos}>
                <img
                  src={securePaymentsByLogo}
                  alt={i18next.t("paymentLinkInfo.drawer.securePaymentsBy")}
                  className={style.securityLogo}
                />
                <img src={cibestLogo} alt="Grupo Cibest" className={style.securityLogoSecondary} />
              </div>
            </div>
          </div>
        </aside>
      </div>
    )
  }
}

MerchantInfoDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  merchantName: PropTypes.string,
  store: PropTypes.object,
}
